import ENDPOINTS from "./api/endpoints";
import apiClient from "./api/client";// make sure this import exists
 
const USE_MOCK_STATS   = false;  
const USE_MOCK_ITEMS   = false;  
const USE_MOCK_HISTORY = false;  
const USE_MOCK_SUBMIT  = false;
 
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
 
// ── Mock Inventory Items for Adjustment ──────────────────────────
 
 
// ── Service ──────────────────────────────────────────────────────
const stockAdjustmentService = {
  async getInventoryItemsForAdjustment(branchId) {
  if (USE_MOCK_ITEMS) {
    await delay(400);
    return [...mockInventoryItems];
  }
  const params = { isActive: true };
  if (branchId) params.branchId = branchId;
  const response = await apiClient.get(ENDPOINTS.STOCK_ADJUSTMENTS.ITEMS, { params });

  return response.map((item) => ({
    id:           item.id,
    name:         item.name,
    categoryName: item.category?.name ?? 'Uncategorized',
    uom:          item.uom?.name ?? '',
    uomSymbol:    item.uom?.symbol ?? '',
    systemStock:  item.currentStock ?? 0,
    unitCost:     item.unitCost ?? 0,
  }));
},
 
  async getAdjustmentHistory(filters = {}) {
  if (USE_MOCK_HISTORY) {
    await delay(400);
    let result = [...mockAdjustmentHistory];
    if (filters.search) {
      const q = filters.search.toLowerCase();
      result = result.filter((a) => a.itemName.toLowerCase().includes(q) || a.adjustedBy.toLowerCase().includes(q));
    }
    if (filters.reason)   result = result.filter((a) => a.reason === filters.reason);
    if (filters.fromDate) result = result.filter((a) => a.createdAt >= filters.fromDate);
    if (filters.toDate)   result = result.filter((a) => a.createdAt <= filters.toDate + 'T23:59:59Z');
    return result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }
 const params = {};
if (filters.search) params.itemName = filters.search;
if (filters.reason) params.reason   = filters.reason;
if (filters.period) {
  params.period = filters.period;
} else {
  if (filters.fromDate) params.fromDate = filters.fromDate;
  if (filters.toDate)   params.toDate   = filters.toDate;
}
  const response = await apiClient.get(ENDPOINTS.STOCK_ADJUSTMENTS.HISTORY, { params });

  return response.map((item) => ({
    id:            item.id,
    itemName:      item.itemName,
    previousStock: item.stockBefore  ?? 0,
    newStock:      item.stockAfter   ?? 0,
    variance:      item.quantity     ?? 0,
    reason:        item.reason,
    adjustedBy:    item.createdBy,
    createdAt:     item.createdAt,
    costImpact:    item.costImpact   ?? 0,
    notes:         item.notes        ?? '',
  }));
},
 
  async submitAdjustments(adjustments) {
  if (USE_MOCK_SUBMIT) {
    await delay(600);
    adjustments.forEach((adj) => {
      const item = mockInventoryItems.find((i) => i.id === adj.inventoryItemId);
      if (!item) return;
      const previousStock = item.systemStock;
      const newStock = adj.actualCount;
      const variance = newStock - previousStock;
      const costImpact = Math.round(variance * item.unitCost);
      mockAdjustmentHistory.unshift({
        id: nextAdjId++,
        itemId: item.id,
        itemName: item.name,
        previousStock,
        newStock,
        variance,
        reason: adj.reason,
        adjustedBy: 'Admin',
        createdAt: new Date().toISOString(),
        costImpact,
        notes: adj.notes || '',
      });
      item.systemStock = newStock;
    });
    return { success: true, count: adjustments.length };
  }
 
  const payload = adjustments.map((adj) => ({
    ...adj,
    reason: adj.reason.toUpperCase(),
  }));
  return apiClient.post(ENDPOINTS.STOCK_ADJUSTMENTS.ADJUST, payload);
},
 
  async getStats(branchId, fromDate, toDate,period) {
    if (USE_MOCK_STATS) {
      await delay(300);
      const history = mockAdjustmentHistory;
      const totalAdjustments = history.length;
      const uniqueItems = new Set(history.map((h) => h.itemId)).size;
      const netValue = history.reduce((sum, h) => sum + h.costImpact, 0);
      const avgVariance = history.length
        ? Math.abs(history.reduce((sum, h) => sum + (h.variance / (h.previousStock || 1)) * 100, 0) / history.length)
        : 0;
      return {
        totalAdjustments,
        totalItemsAdjusted: uniqueItems,
        netAdjustmentValue: netValue,
        avgVariancePercent: Math.round(avgVariance * 10) / 10,
      };
    }
      const params = {};
  if (period) {
    params.period = period;
  } else {
    if (fromDate) params.fromDate = fromDate;
    if (toDate)   params.toDate   = toDate;
  }
  return apiClient.get(ENDPOINTS.STOCK_ADJUSTMENTS.STATS, { params });
  },
};
 
export default stockAdjustmentService;